import { render, staticRenderFns } from "./DownloadCloudIcon.vue?vue&type=template&id=40cec204&"
import script from "./DownloadCloudIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadCloudIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports